import Dygraph from 'dygraphs';

// If you need it globally (e.g., for inline JS or legacy code):
window.Dygraph = Dygraph;
window.MTGGoldfishDygraph = window.MTGGoldfishDygraph || {};
if (typeof window.MTGGoldfishDygraph.flushDygraphReady === "function") {
  window.MTGGoldfishDygraph.flushDygraphReady();
} else {
  window.MTGGoldfishDygraph.dygraphReady = true;
}
